/// <amd-dependency path="Bindings/baoSearcher" />
/// <amd-dependency path="Bindings/baoDateTimeBox" />
/// <amd-dependency path="Bindings/baoDateTimePicker" />
import * as $ from "jquery";
import Bao from "./../../services/bao-service";
import baoRouter from "./../../services/bao-router";
import BaoDialog from "./../../factories/bao-dialog";
import * as ko from "knockout";

/*
 * View-model for the EmploymentStatistics report
 * */
class EmploymentStatisticsReport {

    Bao = Bao;
    TabPage: Factories.TabPage;
    Parent;
    OrgUnitId = ko.observable('');
    OrgUnitName = ko.observable('');
    ShiftGroupId = ko.observable('');
    ShiftGroupName = ko.observable('');
    StartDateTime = ko.observable('');
    EndDateTime = ko.observable('');
    

    PageSize = ko.observable(0);
    TotalRows = ko.observable(0);
    PageIndex = ko.observable(0);
    ShiftBookId = ko.observable('');
    ShiftBookName = ko.observable('');
    ShiftBook = ko.observable();
    Calendar = ko.observableArray([]);
    EmploymentStatisticsCollection = ko.observableArray([]);
    IsReportResultEmpty = ko.observable(false);
    ReportHTML = ko.observable<HTMLElement>();
    LastRowCellHTML = ko.observable<HTMLElement>();
    AbsentCellHTML = ko.observable<HTMLElement>();
    ShowAllPersonCheck = ko.observable(false);

    AllPersonChecked: KnockoutObservable<boolean> = ko.observable(false);
    ShowOtherShiftGroups: KnockoutObservable<boolean> = ko.observable(false);
    ShowUnvalidQualifications: KnockoutObservable<boolean> = ko.observable(false);
    inTraining: KnockoutObservable<boolean> = ko.observable(false);
    SidebarTop: KnockoutObservable<string> = ko.observable('0');
    HeaderLeft: KnockoutObservable<string> = ko.observable('0');

    SearcherShiftBook: Bindings.baoSearcher = {
        ObjectId: this.ShiftBookId,
        ObjectValue: 'Name',
        SearchType: 'ShiftBook',
        SelectedItem: this.ShiftBook,
        AutoComplete: true,
        AutoSearch: true,
        CustomFilter: {
            CurrentUserHasReadPermission: true,
            ShiftbookTypeId: '1AB743AA-C33C-4DB9-8920-3C8E79B501E3'
        }
    };

    SearcherShiftGroup: Bindings.baoSearcher = {
        ObjectId: this.ShiftGroupId,
        ObjectValue: 'Name',
        SearchType: 'ShiftGroup',
        AutoComplete: true,
        AutoSearch: true,
        CustomFilter: { ShiftbookIds: this.ShiftBookId }
    };

    /*
     * Validates set filters before displaying the report
     * */
    protected checkFilters(isInInit: boolean): boolean {
        var completed = true;
        if (!this.ShiftGroupId() || !this.ShiftBookId() || !this.StartDateTime() || !this.EndDateTime()) {
            completed = false;
        }
        if (!completed && !(isInInit == true)) {
            var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }

    protected recalcScroll() {
        this.SidebarTop($(this.ReportHTML()).find("#content")[0].getBoundingClientRect().top + 'px');
        this.HeaderLeft(-window.pageXOffset + 'px');
    }

    constructor(parent: any, params: any) {
        this.Parent = parent;
        this.Parent.FormReportId.subscribe(() => {
            this.beforeClose();
        });

        if (params) {
            if (params.ShiftBookId) {
                this.ShiftBookId(params.ShiftBookId);
                this.ShiftBookName(params.ShiftBookName);
            }
            if (params.ShiftGroupId) {
                this.ShiftGroupId(params.ShiftGroupId);
                this.ShiftGroupName(params.ShiftGroupName);
            }
            if (params.FromDate) {
                this.StartDateTime(params.FromDate);
            }
            if (params.ToDate) {
                this.EndDateTime(params.ToDate);
            }
        }

        this.TabPage = parent.TabPage;

        this.TabPage.IsActiveTab.subscribe(() => {
            if (this.TabPage.IsActiveTab()) {
                this.recalcSchedulePosition();
                this.recalcScroll();
            }
        });
        this.LastRowCellHTML.subscribe(() => {
            $(this.AbsentCellHTML()).height($(this.LastRowCellHTML()).height());
        });
        this.ShiftBook.subscribe(() => {
            this.ShiftGroupId('');
            this.ShiftGroupName('');
        });
    }

    loaded() {
        this.TabPage.IsLoading(true);
        $(this.ReportHTML()).parents(".col-lg-12").eq(1).find("select.form-control").eq(0).css({ "position": "fixed", "width": "65.7%", "z-index": "500" });
        window.addEventListener('scroll', this.ScrollEventHandler);
        window.addEventListener('resize', this.ResizeEventHandler);
        this.recalcSchedulePosition();
        this.recalcScroll();
        this.getMetaDataFromServer();
    }

    /**
     * Returns and sets metadata from the server
     * */
    protected getMetaDataFromServer() {
        return Bao.post("ReportCenter/EmploymentStatisticsReportMetadata").then(result => {
            if (!this.ShiftBookId()) {
                this.ShiftBookId(result.ShiftBookId);
                this.ShiftBookName(result.ShiftBookName);
            }
            if (!this.ShiftGroupId()) {
                this.ShiftGroupId(result.ShiftGroupId);
                this.ShiftGroupName(result.ShiftGroupName);
            }
            if (!this.StartDateTime()) {
                this.StartDateTime(result.StartDateTime);
            }
            if (!this.EndDateTime()) {
                this.EndDateTime(result.EndDateTime);
            }
            this.TabPage.IsLoading(false);
        });
    }

    protected recalcSchedulePosition() {
        $(this.ReportHTML()).find(".employment-statistics-report").css("top", $(this.ReportHTML()).find(".filters").height() + 33);
    }

    protected ResizeEventHandler = (e) => {
        this.recalcSchedulePosition();
        this.recalcScroll();
    }

    protected ScrollEventHandler = (e) => {
        e.preventDefault();
        this.recalcScroll();
    }

    /**
     * Downloads the report
     * */
    Download = () => {
        if (!this.IsComplete()) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
            return;
        }
        if (!this.IsValidDateFields()) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("DateTimeFieldsAreInvalid"), "info");
            return;
        }
              
        this.OrgUnitId = this.ShiftBookId;
        var filterobjects = ["OrgUnitId", "ShiftGroupId", "StartDateTime", "EndDateTime", "AllPersonChecked", "ShowOtherShiftGroups", "ShowUnvalidQualifications","inTraining"];
        var data = {
            filter: this.Parent.GetFilterHashObject(filterobjects, this)
        };
        this.TabPage.IsLoading(true);
        Bao.post("ReportCenter/GetDownloadEmploymentStatisticsReport", JSON.stringify(data)).then(result => {
            this.TabPage.IsLoading(false);
            if (result && result.Result == true) {
                baoRouter.setHash("document/" + result.Message);
            } else {
                new BaoDialog(Bao.Session.ApplicationName, result.Message, "info");
            }
        });
    }
    /**
     * Date validator
     * */
    IsValidDateFields = () => {
        return Boolean(Bao.Utils.String.IsNullOrEmpty(this.StartDateTime()) || Bao.Utils.String.IsNullOrEmpty(this.EndDateTime()) ||
            (Number(this.EndDateTime()) >= Number(this.StartDateTime())));
    };

    /**
     * Validator of completed fields
     * */
    IsComplete() {
        return Boolean(
            !Bao.Utils.String.IsNullOrEmpty(this.StartDateTime()) && !Bao.Utils.String.IsNullOrEmpty(this.EndDateTime()) &&
            !Bao.Utils.String.IsNullOrEmpty(this.ShiftGroupId()) && !Bao.Utils.String.IsNullOrEmpty(this.ShiftBookId()));
            
    }
    
    protected beforeClose() {
        // remove the eventlistener
        window.removeEventListener('scroll', this.ScrollEventHandler);
        window.removeEventListener('resize', this.ResizeEventHandler);
        $(this.ReportHTML()).parents(".col-lg-12").eq(1).find("select.form-control").eq(0).css({ "position": "static", "width": "100%", "z-index": "inherit" });
    }
}

export default EmploymentStatisticsReport